import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Inject, Injectable, NgZone, Optional, PLATFORM_ID } from '@angular/core';

import { BREAKPOINTS, Breakpoints, SSR_OPTIONS, SsrOptions } from './breakpoints-config';
import { BreakpointsHelper } from '@libs/breakpoints/breakpoints-helper';

/**
 * Wrapper service for breakpoints `BreakpointsHelper` which exposes different utils based on the window object.
 * Additionally you get some shortcuts for platform-browser and platform-server
 */
@Injectable()
export class BreakpointService extends BreakpointsHelper {
    constructor(
        @Inject(PLATFORM_ID) private _platformId: Record<string, unknown>,
        @Optional()
        @Inject(BREAKPOINTS)
        _breakpoints: Breakpoints,
        @Optional()
        @Inject(SSR_OPTIONS)
        _ssrOptions: SsrOptions,
        private readonly ngZone: NgZone
    ) {
        super(isPlatformBrowser(_platformId), _breakpoints, _ssrOptions, ngZone);
    }

    isBrowser(): boolean {
        return isPlatformBrowser(this._platformId);
    }

    isServer(): boolean {
        return isPlatformServer(this._platformId);
    }
}
